import {AfterViewInit, Component} from '@angular/core';
import {AuthService} from '../../../services/auth/auth.service';
import {Router} from '@angular/router';
import {Route} from '../../../enum/route';
import {LoadingService} from '../../../services/loadingService/loading.service';

@Component({
    selector: 'app-start-page',
    templateUrl: './start-page.component.html',
    styleUrls: ['./start-page.component.scss', '../../../../styles/loading.scss'],
    standalone: false
})
export class StartPageComponent implements AfterViewInit {

  Route = Route;

  constructor(public readonly authService: AuthService,
              private readonly loadingService: LoadingService,
              public readonly router: Router) {
  }

  ngAfterViewInit(): void {
    this.loadingService.stopLoading();
  }

  login() {
    this.loadingService.startLoading();
    this.authService.login();
  }

  logout() {
    this.authService.logout();
  }

  isCallbackUrl(): boolean {
    return this.router.url.startsWith('/?callback');
  }

}


